@if (userLoggedIn$ | async) {
    <app-header (sidebarButtonClicked)="toggleSidebar()"></app-header>
}

<div id="page-content">

    <dx-drawer template="template" height="100%" [opened]="sidebarOpened">

        <app-side-bar *dxTemplate="let data of 'template'"></app-side-bar>

        <div class="main-page" [ngClass]="{'logged-in-content': userLoggedIn$ | async}">
            <app-permissions-banner></app-permissions-banner>
            <app-incoming-call-card
                    *ngIf="activeIncomingCall"
                    [incomingCallId]="activeIncomingCall.callId"
                    [isActiveCall]="true">
            </app-incoming-call-card>
            <app-incoming-call-card
                    *ngFor="let call of secondaryIncomingCalls; let i = index; trackBy: trackByCallId"
                    [incomingCallId]="call.callId"
                    [isActiveCall]="false"
                    [cardIndex]="i">
            </app-incoming-call-card>
            <router-outlet></router-outlet>
        </div>

    </dx-drawer>

</div>

<app-connectivity-overlay></app-connectivity-overlay>
<app-dialog></app-dialog>
<app-call-state-debug-card *ngIf="!isProduction"></app-call-state-debug-card>
